import NextImage from 'next/image'
import { Nameplate } from '@mc/design-system'
import { useStaticData } from '@mc/static-data-react'
import { PrunedCourse } from 'libs/server/api'
import type { HeroData } from '../../types'
import { getNameplateLabel } from '../utils'
import classes from './Hero.module.scss'

export const DefaultNameplateMobile = ({ data }: { data: HeroData }) => {
  const { course } = useStaticData<{
    course: PrunedCourse
  }>()

  if (data.isDynamicNameplate) {
    return (
      <div className='mc-my-3'>
        <div className='d-flex flex-column align-items-start'>
          <h1 className='mc-text-d1 mc-text--brand mc-text--uppercase'>
            {data.header}
          </h1>
          <h2 className='mc-text-h4 mc-mt-4'>{data.nameplate}</h2>
        </div>
      </div>
    )
  }

  if (!course.leftAlignedNameplate) return null

  const isPowerPlaybook = course.slug === 'the-power-playbook' // Workaround for https://ourmasterclass.slack.com/archives/C02S9J0L0DN/p1758902506859879
  const nameplate = isPowerPlaybook
    ? data.nameplate
    : course.leftAlignedNameplate
  // PEN-6909: reserve the box using the ratio of whichever image we actually
  // render — the-power-playbook renders data.nameplate, not leftAlignedNameplate.
  const nameplateAspectRatio = isPowerPlaybook
    ? course.nameplateAspectRatio
    : course.leftAlignedNameplateAspectRatio

  return (
    <div className='mc-my-3'>
      <Nameplate
        size='small'
        image={
          <h1
            aria-label={getNameplateLabel(course)}
            className='mc-w-100 d-flex align-items-start justify-content-start mc-mb-3 position-relative'
          >
            <NextImage
              alt=''
              className={classes.nameplateImage}
              src={nameplate || ''}
              fill
              style={{
                objectFit: 'contain',
                // PEN-6909: reserve exact layout space to prevent CLS.
                ...(nameplateAspectRatio
                  ? { aspectRatio: nameplateAspectRatio }
                  : {}),
              }}
              sizes='150px'
              priority
            />
          </h1>
        }
        subText={data.header || ''}
        align='bottom'
      />
    </div>
  )
}
